import {
    VISITSTORETOPURCHASE_GET_REQUEST,
    VISITSTORETOPURCHASE_ZIPCODE_CHANGE,
} from '../actionTypes/VisitStoreToPurchaseActionTypes';

const getVisitStoreToPurchaseAction = (payload) => ({
    type: VISITSTORETOPURCHASE_GET_REQUEST,
    visitStoreToPurchase: payload,
});

export const updateVisitStoreToPurchaseZipcode = (payload) => ({
    type: VISITSTORETOPURCHASE_ZIPCODE_CHANGE,
    payload,
});

export default getVisitStoreToPurchaseAction;
